import styled from "styled-components";
import Variables from "../../assets/styleVariables";

export const PanelWrapper = styled.div`
	position: relative;
	display: ${props => props.show === false ? 'none' : 'flex'};
	border-radius: 4px;
	box-shadow: 0 0 2px 0 rgba(0, 0, 0, 0.16);
	margin-bottom: 20px;
	border: solid 1px ${Variables.colors.complementary_400};
	height:80%;	
`;

export const PanelBody = styled.div`	
	display: flex;
	width: 100%;
	flex-direction: ${props => props.directionCol ? 'column' : 'row'};
	padding: 15px 32px 15px 0;
`;

export const PanelHeader = styled.div`	
	font-size: 20px;
	line-height: 1.55;
	color: ${Variables.colors.complementary_800};
`;

export const PanelFooter = styled.div`	
	display: flex;	
	border-top: 1px solid ${Variables.colors.complementary_400};
	margin-right: -32px;
	padding: 15px 32px 0;
	&>div{
	   & > button{
	  color: ${Variables.colors.primary_vivid};	   
	   }
	}
`;

export const Divider = styled.hr`
	border: 0;
	width: 100%;
	height: 1px;
	background: ${Variables.colors.complementary_400};
	margin-bottom: 20px;
`;